import OapMenShadeMatcher from './code/Scripts/Components/OapMenShadeMatcher.vue';

export default {
  components: {
    OapMenShadeMatcher,
  },
};
